module.exports = __webpack_public_path__ + "img/eye-1.dfc8f11f.svg";